import { render, staticRenderFns } from "./ExamModeIndex.vue?vue&type=template&id=14be2b46&"
import script from "./ExamModeIndex.vue?vue&type=script&lang=ts&"
export * from "./ExamModeIndex.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports